import { Intent, Tag, Tooltip } from "@blueprintjs/core";
import classNames from "classnames";
import css from "./StaleScenarioTag.module.scss";

const STALE_TOOLTIP =
    "The cluster's model files or study inputs have changed since these results ran.";

export const StaleScenarioTag: React.FC<{ className?: string }> = ({
    className
}) => (
    <Tooltip
        content={STALE_TOOLTIP}
        placement="top"
        compact
        className={classNames(css["StaleScenarioTag-target"], className)}
    >
        <Tag minimal round intent={Intent.WARNING}>
            Stale
        </Tag>
    </Tooltip>
);
